import styles from '../dashboardCards.module.css';

const W = 320;
const H = 120;
const PAD = { top: 8, bottom: 18 };

/** Single-series bars: filled = completed km, outlined = planned km. Text equivalent in aria-label. */
const WeeklyLoadChart = ({ days, label }) => {
    const max = Math.max(...days.map(d => d.plannedKm), 1);
    const slot = W / days.length;
    const plot = H - PAD.top - PAD.bottom;
    return (
        <svg className={styles.chart} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={label}>
            {days.map((d, i) => {
                const x = i * slot + slot * 0.2;
                const w = slot * 0.6;
                const planned = (d.plannedKm / max) * plot;
                const done = (d.completedKm / max) * plot;
                return (
                    <g key={d.key}>
                        {planned > 0 && (
                            <rect x={x} y={PAD.top + plot - planned} width={w} height={planned} rx="3" fill="#fff" stroke="var(--blue-500)" strokeWidth="1.5" />
                        )}
                        {done > 0 && <rect x={x} y={PAD.top + plot - done} width={w} height={done} rx="3" fill="var(--blue-700)" />}
                        <text x={x + w / 2} y={H - 4} textAnchor="middle">
                            {d.label[0]}
                        </text>
                    </g>
                );
            })}
            <line x1="0" x2={W} y1={PAD.top + plot} y2={PAD.top + plot} stroke="var(--border-strong)" />
        </svg>
    );
};

export default WeeklyLoadChart;
